import { OrderResponse, CreateOrderRequest } from 'models/Orders'
import { api } from '../api'

export const ordersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation<
      OrderResponse,
      { campaignId: string; paymentMethod: string; body: CreateOrderRequest }
    >({
      query: ({ campaignId, paymentMethod, body }) => ({
        url: `/orders?campaignId=${campaignId}&payment_method=${paymentMethod}`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useCreateOrderMutation,
  endpoints: { createOrder },
} = ordersApi
